import React, { useRef, useEffect } from 'react'
import Loading from 'components/Loading'
import s from './index.module.less'

/**
 * 滚动加载更多组件
 * @param {function} fetchMore 请求数据函数
 * @param {element} rootEl 根元素
 * @param {bool} hasMore 是否可以加载更多
 */
/* eslint-disable */
const LoadMore = ({ fetchMore, rootEl = null, hasMore = false, loading = false }) => {
  const $el = useRef()
  useEffect(() => {
    let el = null
    const options = {
      rootMargin: '0px',
      threshold: 0.1
    }
    const observer = new IntersectionObserver(async (entries) => {
      if (entries[0] && entries[0].isIntersecting) {
        if (loading || !hasMore) {
          return
        }
        try {
          await fetchMore()
        } catch (e) {}
      }
    }, options)
    if ($el?.current) {
      // @ts-ignore
      el = $el.current
      // @ts-ignore
      observer.observe($el.current)
    }
    return () => {
      // @ts-ignore
      if (observer) observer.unobserve(el)
    }
  }, [loading, hasMore])

  return (
    // @ts-ignore
    <div ref={$el} className={s.loadMore}>
      {hasMore && loading && <Loading />}
      {/* {loading && '正在加载...'}
      {!loading && hasMore && '加载更多'}
      {!loading && !hasMore && '已经到底了'} */}
    </div>
  )
}

export default LoadMore
